import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import _ from 'lodash';

import Checkbox from '../forms/checkbox.jsx';
import {SearchForm} from '../search/search-form.jsx';
import { utilsService } from '../../core/services/utils.service';

@observer
export class SearchAndFilter extends React.Component {

  static propTypes = {
    store: PropTypes.object.isRequired,
    forceOpen: PropTypes.bool
  };

  static defaultProps = {
    forceOpen: false
  }

  toggleSearchBox = () => {
    this.props.store.toggleSearchBox();
  }

  handleResetFilters = () => {
    this.props.store.resetFilters();
  }

  handleFilterChange = (target, list) => {
    const checked = target.checked;
    const value = target.value;
    this.props.store.toggleFilter(value, list, checked);
  }

  isDisabled(status) {
    return this.props.store.numAppsWithStatus[status] < 1;
  }

  render() {
    return (<div className="search-container walkthrough-search-and-filter">
      <button
        className="search-toggle as-tab blue"
        onClick={this.toggleSearchBox}
        ref={(ref) => { this.showHideSearch = ref }}>
        Search / Filters
        <i aria-hidden="aria-hidden" className={this.props.store.hideSearchBox
            ? 'icon-arrowDown'
            : 'icon-arrowUp'}>
          <span className="sr-only">{
              this.props.store.hideSearchBox
                ? 'Expand'
                : 'Collapse'
            }
            Search and Filters</span>
        </i>
      </button>
      <span className="sr-only" aria-live="polite" aria-atomic="true">Search and Filters are {
          this.props.store.hideSearchBox
            ? "hidden"
            : "displayed"
        }</span>
      {
        (!this.props.store.hideSearchBox || this.props.forceOpen) && (<div className="search-box">
          <div className="search-form-wrapper">
            <div className="row">
              <div className="col-3">
                <div className="search-title">
                  <h3 className="as-h4">Search</h3>
                </div>
              </div>
              <div className="col-9">
                <SearchForm store={this.props.store}/>
              </div>
            </div>
          </div>
          <div className="search-filters">
            <div className="row">
              <div className="col-3">
                <span className="search-title">
                  <h3 className="as-h4">Status</h3>
                </span>
              </div>
              <div className="col-6">
                <fieldset>
                  <legend className="search-status as-label">
                    <span className="sr-only">Filter</span>
                    Unreleased
                    <span className="sr-only">apps.</span>
                  </legend>
                  <div aria-label="Filter unreleased apps:" className="two-column">
                    {
                      Object.keys(this.props.store.filters.unReleased).map((key, i) => {
                        let label = utilsService.formatStatus(key);

                        return (<Checkbox
                          key={i}
                          id={'checkbox-' + key}
                          value={key}
                          label={_.capitalize(label)}
                          ref={ref => this[key + "Toggle"] = ref}
                          disabled={this.isDisabled(key)}
                          checked={!this.isDisabled(key) && this.props.store.filters.unReleased[key]}
                          handleOnChange={(target) => this.handleFilterChange(target, 'unReleased')} />
                        )
                      })
                    }
                  </div>
                </fieldset>
              </div>
              <div className="col-3">
                <fieldset>
                  <legend className="search-status as-label">
                    <span className="sr-only">Filter</span>
                    Released
                    <span className="sr-only">apps.</span>
                  </legend>
                  <div aria-label="Filter released apps:">
                    {
                      Object.keys(this.props.store.filters.released).map((key, i) => {
                        return (<Checkbox
                          key={i}
                          id={'checkbox-' + key}
                          value={key}
                          label={_.capitalize(key)}
                          ref={ref => {this[key + "Toggle"] = ref}}
                          disabled={this.isDisabled(key)}
                          checked={!this.isDisabled(key) && this.props.store.filters.released[key]}
                          handleOnChange={(target) => this.handleFilterChange(target, 'released')} />
                        )
                      })
                    }
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
          <div className="search-reset">
            <button
              className="float-right btn as-link"
              ref={ref => {this.resetButton = ref}}
              onClick={this.handleResetFilters}>Reset Filters</button>
          </div>
        </div>)
      }
    </div>)
  }
}
